import { createTheme } from '@mui/material/styles';
import * as Tokens from '../bdstokens/build/ts/all_cudaLight_default';
import generatePalette from './paletteTokens';
import generateTypography from './typographyTokens';
const themeFont = 'Manrope';
const palette = generatePalette(Tokens);
const typography = generateTypography(Tokens);
const cudaLight = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none'
                },
                body: {
                    WebkitFontSmoothing: 'antialiased',
                    textRendering: 'optimizeLegibility',
                    fontSynthesis: 'none',
                    fontFamily: themeFont
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                thumb: {
                    backgroundColor: Tokens.switchKnobColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: Tokens.switchKnobColorBgSelectedDefault
                    },
                    borderWidth: Tokens.switchKnobBorderWidth,
                    borderRadius: Tokens.switchKnobRadius
                },
                track: {
                    backgroundColor: Tokens.switchTrackColorBgUnselectedDefault,
                    '&$checked': {
                        backgroundColor: Tokens.switchTrackColorBgSelectedDefault
                    },
                    borderWidth: Tokens.switchTrackBorderWidth,
                    borderRadius: Tokens.switchTrackRadius
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: Tokens.buttonRadius,
                    borderWidth: Tokens.buttonBorderWidth,
                    fontFamily: themeFont
                },
                containedPrimary: {
                    boxShadow: 'none',
                    backgroundColor: Tokens.buttonColorBgEmphasisDefault,
                    color: Tokens.buttonColorTextEmphasis,
                    '&:hover': {
                        backgroundColor: Tokens.buttonColorBgEmphasisHover
                    },
                    '&:disabled': {
                        backgroundColor: Tokens.buttonColorBgDisabled,
                        color: Tokens.buttonColorTextDisabled
                    }
                },
                containedSecondary: {
                    boxShadow: 'none',
                    backgroundColor: Tokens.buttonColorBgNeutralDefault,
                    color: Tokens.buttonColorTextNeutral,
                    '&:hover': {
                        backgroundColor: Tokens.buttonColorBgNeutralHover
                    },
                    '&:disabled': {
                        backgroundColor: Tokens.buttonColorBgDisabled,
                        color: Tokens.buttonColorTextDisabled
                    }
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderWidth: Tokens.alertBorderWidth,
                    borderRadius: Tokens.alertRadius
                },
                standardWarning: {
                    backgroundColor: Tokens.alertColorBgWarningNeutral,
                    border: Tokens.alertColorBorderWarningNeutral
                },
                standardError: {
                    backgroundColor: Tokens.alertColorBgErrorNeutral,
                    border: Tokens.alertColorBorderErrorNeutral
                },
                standardInfo: {
                    backgroundColor: Tokens.alertColorBgInfoNeutral,
                    border: Tokens.alertColorBorderInfoNeutral
                },
                standardSuccess: {
                    backgroundColor: Tokens.alertColorBgSuccessNeutral,
                    border: Tokens.alertColorBorderSuccessNeutral
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    borderRadius: Tokens.avatarRadiusRound,
                    borderWidth: Tokens.avatarBorderWidthDefault
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    height: Tokens.iconSizeS,
                    width: Tokens.iconSizeS
                },
                sizeMedium: {
                    height: Tokens.iconSizeM,
                    width: Tokens.iconSizeM
                },
                sizeLarge: {
                    height: Tokens.iconSizeL,
                    width: Tokens.iconSizeL
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: Tokens.chipRadiusRound,
                    borderWidth: Tokens.chipBorderWidth,
                    fontFamily: themeFont
                },
                colorPrimary: {
                    backgroundColor: Tokens.chipColorBgInteractiveEmphasisDefault,
                    border: Tokens.chipColorBorderInteractiveEmphasisDefault,
                    '&.disabled': {
                        backgroundColor: Tokens.chipColorBgInteractiveDisabled,
                        border: Tokens.chipColorBorderInteractiveDisabled
                    }
                },
                colorSecondary: {
                    backgroundColor: Tokens.chipColorBgInteractiveNeutralDefault,
                    border: Tokens.chipColorBorderInteractiveNeutralDefault
                }
            }
        }
    },
    custom: {
        identifier: 'cudaLight'
    },
    palette: palette,
    typography: typography
});
export default cudaLight;
//# sourceMappingURL=cudaLight.js.map